/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Close1Inputs */

const he_extension_trackermodal_close1 = /** @type {(inputs: Extension_Trackermodal_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סגירה`)
};

const en_extension_trackermodal_close1 = /** @type {(inputs: Extension_Trackermodal_Close1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Extension_Trackermodal_Close1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_close1 = /** @type {((inputs?: Extension_Trackermodal_Close1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Close1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_close1(inputs)
	return en_extension_trackermodal_close1(inputs)
});
export { extension_trackermodal_close1 as "extension_trackerModal_close" }